import React from 'react';
import { Button } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';

const SubmitArrowButton = ({ onClick, disabled, style, deepResearch = false, ...props }) => {
  const defaultStyle = {
    position: 'absolute',
    right: '10px',
    bottom: '10px',
    height: '40px',
    width: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  };

  const buttonStyle = {
    ...defaultStyle,
    ...style,
    ...(deepResearch && !disabled && {
      backgroundColor: '#722ed1', // Purple color for deep research
      borderColor: '#722ed1',
      '&:hover': {
        backgroundColor: '#531dab',
        borderColor: '#531dab'
      }
    })
  };

  return (
    <Button
      type="primary"
      shape="round"
      icon={<ArrowRightOutlined />}
      onClick={onClick}
      disabled={disabled}
      style={buttonStyle}
      {...props}
    />
  );
};

export default SubmitArrowButton; 